module.exports = __webpack_public_path__ + "static/img/1045_small.465cb4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1045_small.png
// module id = 6qnW
// module chunks = 1